// extracted by mini-css-extract-plugin
module.exports = {"Category":"Category_Category__hhf98","Active":"Category_Active__2UAkD"};